import UserContainer from '@user/containers/UserContainer';
export default UserContainer;
